import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";

// Lazy loading de páginas para code splitting
const HomePage = lazy(() => import("../pages/Home/HomePage"));
const ClabeValidatorPage = lazy(() => import("../pages/ClabeValidator/ClabeValidator"));
const PortadaCanvas = lazy(() => import("../pages/portada-canvas/PortadaCanvas"));
const CurpGeneratorPage = lazy(() => import("../pages/CurpGenerator/CurpGenerator"));
const NotFoundPage = lazy(() => import("../pages/NotFound/NotFoundPage"));

// Componente de carga
function LoadingFallback() {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
    >
      <CircularProgress />
    </Box>
  );
}

function AppRoutes() {
  return (
    <BrowserRouter>
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          <Route index element={<HomePage />} />
          <Route path="clabe-validator" element={<ClabeValidatorPage />} />
          <Route path="portada-canvas" element={<PortadaCanvas />} />
          <Route path="curp-generator" element={<CurpGeneratorPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default AppRoutes;
